export default __webpack_public_path__ + "static/media/abc.2fc79e42.png";